import { Routes } from '@angular/router';

import { CMS_PERMISSIONS } from '../../core/constants/permissions';
import { permissionGuard } from '../../core/guards/permission.guard';

export const auditRoutes: Routes = [
  {
    path: 'auditorias',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.audits.viewAny,
    },
    loadComponent: () => import('./pages/table/table').then((m) => m.AuditsTable),
  },
];
